import DatePicker from "../ui/DatePicker";

const DateInput = ({
  label,
  value,
  onChange,
  placeholder = "Pick a date",
  disabled = false,
  mode = "single",
  error = "",
  showYearDropdown = true,
  showTimePicker = false,
  // New props
  allowFuture = true,
  allowPast = true,
  minDate,
  maxDate,
  excludedDates = [],
  maxSelectableRange,
  ...rest
}) => {
  return (
    <div className="w-full flex flex-col gap-1">
      {/* Label */}
      {label && (
        <label className="text-subtitle2 font-ptsans text-secondary/90 font-medium pl-2">
          {label}
        </label>
      )}

      {/* Input Field with Calendar Icon */}
      <div className="relative w-full">
        <DatePicker
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          mode={mode}
          disabled={disabled}
          showYearDropdown={showYearDropdown}
          showTimePicker={showTimePicker}
          // New props
          allowFuture={allowFuture}
          allowPast={allowPast}
          minDate={minDate}
          maxDate={maxDate}
          excludedDates={excludedDates}
          maxSelectableRange={maxSelectableRange}
          {...rest}
        />
      </div>
      {error && (
        <span className="text-caption text-red-500 font-ptsans pl-2">
          {error}
        </span>
      )}
    </div>
  );
};

export default DateInput;
